import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import { StrapiCreate, StrapiSingle, StrapiUpdate } from '../../types/strapi/strapi'
import Form from '../../types/api/form'

export const formsApi = createApi({
    reducerPath: 'formsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Forms'],
    endpoints: builder => ({
        createForm: builder.mutation<StrapiSingle<Form>, StrapiCreate<Form>>({
            query: body => ({
                url: '/forms',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Forms'],
        }),
        deleteForm: builder.mutation<void, string>({
            query: docId => ({ url: `/forms/${docId}`, method: 'DELETE' }),
            invalidatesTags: ['Forms'],
        }),
        updateForm: builder.mutation<StrapiSingle<Form>, StrapiUpdate<Form>>({
            query: ({ docId, body }) => ({
                url: `/forms/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Forms'],
        }),
    }),
})

export const { useCreateFormMutation, useDeleteFormMutation, useUpdateFormMutation } = formsApi
